<template>
    <div>
        <div class="row">
            <div class="col text-center">
                <span class="d-none d-sm-block"><h2>Bonne séance {{this.$store.getters.username}} !</h2></span>
                <span class="d-block d-sm-none"><h4>Bonne séance {{this.$store.getters.username}} !</h4></span>
            </div>
        </div>
        <div class="row">
            <div class="col text-center" >
                <div class="alert alert-info">
                    <span class="d-none d-sm-block"><h2>série {{serieIndex + 1}}</h2></span>
                    <span class="d-block d-sm-none">série {{serieIndex + 1}}</span>
                </div>

            </div>
        </div>
        <div class="row">
            <div class="col text-center">
                <span class="d-none d-sm-block"><h1>Exercice : {{showExerciseName}}</h1></span>
                <span class="d-block d-sm-none"><h3>{{showExerciseName}}</h3></span>
                <!--<h1>Exercice : {{-->
                    <!--exercises[exerciseIndex].levels[(results[serieIndex][exerciseIndex].level.rank) -1].hasOwnProperty('name')-->
                    <!--? exercises[exerciseIndex].levels[(results[serieIndex][exerciseIndex].level.rank) -1].name-->
                    <!--: exercises[exerciseIndex].name}}-->
                <!--</h1>-->
            </div>
        </div>
        <div v-if="(serieIndex == 0)
                    && !$store.getters.isFirstTraining
                    && !isLeftSideExercise" class="row form ">
            <div class="col-md-12 col-lg text-center">
                <p>Sélectionner votre niveau:</p>
            </div>
            <div class="col-md-12 col-lg text-center">
                <div class="form-check form-check-inline"  v-for="level in exercises[exerciseIndex].levels">
                    <span :id="'wrapper-' + level.rank">
                    <input class="form-check-input" :id="'level-' + level.rank" type="radio"
                           v-model="results[serieIndex][exerciseIndex].level"
                           :value=level :disabled="isLevelDisabled(level, serieIndex, exerciseIndex)">
                    <label class="form-check-label" :for="'level-' + level.rank">{{level.rank}}</label></span>
                    <b-tooltip :target="'wrapper-' + level.rank" :disabled=!isLevelDisabled(level)>Ce niveau n'est pas disponible pour cet exercice.</b-tooltip>
                </div>
            </div>
        </div>
        <div v-else class="row">
            <div class="col text-center">Vous travaillez le niveau {{results[serieIndex][exerciseIndex].level.rank}}</div>
        </div>
        <div class="row">
            <div class="col text-center">
                <span class="d-none d-sm-block"><h3>Voici la position pour cet exercice</h3></span>
                <div class="clearfix">
                    <transition>
                        <b-img center fluid rounded class="fadeIn border border-primary"
                               :src="imageLink(exerciseIndex, results[serieIndex][exerciseIndex].level.rank)"
                               alt="Illustration de l'exercice"></b-img>
                    </transition>
                </div>
            </div>
        </div>

        <app-stopwatch v-if="results[serieIndex][exerciseIndex].duration == null"
                       :maxTime="(this.$store.getters.debug ? this.$store.getters.maxTime / 20 : this.$store.getters.maxTime)"
                       :interval="(this.$store.getters.debug ? 400 : 1000)"
                       :soundMode="this.$store.getters.soundMode" @timeSubmitted="setTime"></app-stopwatch>
        <div v-else>
            <div class="row">
                <div class="d-none d-sm-block col text-center"><h1>{{results[serieIndex][exerciseIndex].duration}} sec.</h1></div>
                <div class="d-block d-sm-none col text-center"><h3>{{results[serieIndex][exerciseIndex].duration}} sec.</h3></div>
            </div>
            <hr class="d-none d-sm-block">
            <div class="row pb-3">
                <div class="col" >
                    <button class="d-none d-sm-block btn btn-square-sm btn-block btn-outline-primary block-center" @click.prevent="results[serieIndex][exerciseIndex].duration = null">Refaire cet exercice</button>
                    <button class="d-block d-sm-none btn btn-square-xs btn-block btn-outline-primary block-center" @click.prevent="results[serieIndex][exerciseIndex].duration = null">Refaire cet exercice</button>
                </div>
            </div>
        </div>
        <hr class="d-none d-sm-bloc">
        <div class="row">
            <div class="col">
                <button class="d-none d-sm-block btn btn-primary float-left" v-on:click="previousStep()" v-if="(serieIndex != 0) || (exerciseIndex != 0 )">retour</button>
                <button class="d-block d-sm-none btn btn-sm btn-primary float-left" v-on:click="previousStep()" v-if="(serieIndex != 0) || (exerciseIndex != 0 )">retour</button>
            </div>
            <div v-if="results[serieIndex][exerciseIndex].duration != null" class="col">
            <button class="d-none d-sm-block btn  btn-primary float-right" v-on:click="nextStep()">suivant</button>
            <button class="d-block d-sm-none btn btn-sm btn-primary float-right" v-on:click="nextStep()">suivant</button>
            </div>
        </div>
    </div>
</template>
<script>
    import Stopwatch from './Stopwatch.vue';
    export default {
        components: {
            AppStopwatch: Stopwatch,
        },
        data: function() {
            return {
                exercises: [],
                results: [],

                // maxTime: 3,
                serieIndex: 0,
                exerciseIndex: 0,
                currentDuration: '',

                //const
                rightSideExceptions : ['Pont Latéral Droit', 'Planche Latérale Droite'],
                leftSideExceptions : ['Pont Latéral Gauche', 'Planche Latérale Gauche'],
                unilateralExceptions : ['Pont Unilatéral'],
            }
        },
        // props: ['username', 'soundMode', 'exercises'],
        computed: {
            showExerciseName: function () {
                let exerciseLevel = this.exercises[this.exerciseIndex].levels[this.results[this.serieIndex][this.exerciseIndex].level.rank-1];
                let exerciseName = this.exercises[this.exerciseIndex].name;
                if((exerciseLevel != undefined)
                    && exerciseLevel.hasOwnProperty('name')) {
                    exerciseName = exerciseLevel.name;
                }
                return exerciseName;
            },
            isLeftSideExercise: function() {
                return this.leftSideExceptions.includes(this.showExerciseName);
            }
        },
        methods: {
            findObjectByKey: function(array, key, value) {
                    for (var i = 0; i < array.length; i++) {
                        if (array[i][key] === value) {
                            return array[i];
                        }
                    }
                    return null;
                },
            isLevelDisabled: function (exerciseLevel, serieIndex, exerciseIndex) {
                let status = false;
                let exerciseName = '';
                if(exerciseIndex != undefined) {
                    exerciseName = exerciseLevel.hasOwnProperty('name') ? exerciseLevel.name : this.exercises[exerciseIndex].name;
                }

                if(exerciseLevel.hasOwnProperty('disabled')) {
                    status = exerciseLevel.disabled;
                }
                //Traitement des exercices du coté gauche


                return status;
            },
            setTime: function (time) {
                this.results[this.serieIndex][this.exerciseIndex].duration =
                    (this.$store.getters.debug ? time * 20 : time);
                this.nextStep();
            },
            getNextExercise: function (results, serieIndex, exerciseIndex) {
                /*
                 * Règles de gestion liée aux exercices
                 */
                const n4Exceptions = [1, 2, 3, 8];
                let next = {
                    exerciseIndex: 0,
                    serieIndex: 0,
                    end: false
                };
                //Cas général : déterminer le prochain exercice à faire "en théorie"
                if ([...results[serieIndex].keys()].indexOf(exerciseIndex + 1) > (-1)) {
                    next.serieIndex = serieIndex;
                    next.exerciseIndex = exerciseIndex + 1;
                } else {
                    next.serieIndex = serieIndex + 1;  //incremente de la série
                    next.exerciseIndex = 0;  //exerciceNextIndex passe à 0
                }
                //Cas particulier : le niveau de l'exercice du pont
                // todo: se débarasser du hard coding de la règle
                if( (exerciseIndex == 4) // exercice du pont latéral gauche
                     && n4Exceptions.includes(results[serieIndex][exerciseIndex].level.rank)) {
                    //Il n'y a pa d'exercice de rang 5, on passe à la série suivante
                    next.serieIndex = serieIndex + 1;  //incremente de la série
                    next.exerciseIndex = 0;  //exerciceNextIndex passe à 0
                }

                // //Vérifier que l'on est pas à la fin des exercices
                if(next.serieIndex < this.results.length) {
                } else {
                    next.end = true;
                }
                return next;
            },
            nextStep: function () {
                /*
                 * Règles de gestion liées aux séries
                 */
                //Détermination du prochaine exercice théorique
                var next = this.getNextExercise(this.results, this.serieIndex, this.exerciseIndex);

                if(next.end) {
                    //Si on a fini les exercices, on génére le programm
                    this.$store.dispatch('updateResults', this.results);
                    this.$router.push({path: '/program'});
                    return;
                }
                //Mettre à jour le niveau de la serie 2 par rapport à la série 1 (si l'utilisateur à changé le niveau)
                if(this.serieIndex == 0) {
                    this.results[1][this.exerciseIndex].level =
                        this.findObjectByKey(this.exercises[this.exerciseIndex].levels, 'rank',
                            this.results[0][this.exerciseIndex].level.rank);
                }

                //Si on travaillait la première série, si l'exercice était du côté droit, alors recopier le niveau de l'exercice po
                if((this.serieIndex == 0)
                    && this.rightSideExceptions.includes(this.showExerciseName)) {
                    this.results[0][this.exerciseIndex + 1].level =
                        this.findObjectByKey(this.exercises[this.exerciseIndex].levels, 'rank',
                            this.results[0][this.exerciseIndex].level.rank);
                }

                //Mettre à jour le niveau de la serie 2 si l'exercice de la série 1 >59s
                if ((next.serieIndex == 1 && next.exerciseIndex == 0 ) //On vient de finir la première série.
                    && !this.$store.getters.isFirstTraining) { //Ce n'est pas la première séance
                        //Pour tous les exercices de la première séance
                        this.results[0].forEach((exercise, index) => {
                            if ((exercise.duration >= this.$store.getters.maxTime) //Temps maximum atteint
                                && (exercise.level.rank < this.exercises[index].levels.length)) { // On n'est pas au niveau maximum déjà)

                                let exerciseLevel = this.results[0][index].level;
                                let exerciseName = this.exercises[index].name;
                                if ((exerciseLevel != undefined)
                                    && exerciseLevel.hasOwnProperty('name')) {
                                    exerciseName = exerciseLevel.name;
                                }
                                if (!this.rightSideExceptions.includes(exerciseName)
                                    && !this.leftSideExceptions.includes(exerciseName)) { //Règle de gestion n°8
                                    console.log("Cas 1: ce n'est pas un exercice latéral droit, ni un exercice latéral gauche  et il y aura une serie 3");


                                    // this.results[1][index].level.rank = this.results[0][index].level.rank + 1; //todo: poser la limite du maximum

                                    this.results[2][index].toSkip = false; //activation de l'exercice en série 3
                                    //Mise à jour du niveau de la deuxième série
                                    this.results[1][index].level =
                                        this.findObjectByKey(this.exercises[index].levels, 'rank',
                                            this.results[0][index].level.rank + 1);

                                }
                                if (this.leftSideExceptions.includes(exerciseName) //Règle de gestion n°9
                                    && this.results[0][index - 1].duration >= (this.$store.getters.maxTime)) {
                                    this.results[1][index].level =
                                        this.findObjectByKey(this.exercises[index].levels, 'rank',
                                            this.results[0][index].level.rank + 1);
                                    this.results[2][index].toSkip = false; //activation de l'exercice en série 3
                                    this.results[1][index - 1].level = this.results[1][index].level;
                                    this.results[2][index - 1].toSkip = false; //activation de l'exercice en série 3
                                }
                                if (this.unilateralExceptions.includes(exerciseName)) { //C'est le pont unilateral
                                    this.results[1][index].level =
                                        this.findObjectByKey(this.exercises[index].levels, 'rank',
                                            this.results[0][index].level.rank + 1);
                                    this.results[2][index].toSkip = false; //activation de l'exercice en série 3
                                    this.results[1][index + 1].level = this.findObjectByKey(this.exercises[index + 1].levels, 'rank',
                                        this.results[1][index].level.rank);
                                    this.results[2][index + 1].toSkip = false; //activation de l'exercice en série 3
                                }
                            }
                        });
                    this.exerciseIndex = next.exerciseIndex;
                    this.serieIndex = next.serieIndex;
                    //Cas particulier du "pont unilatéral" pour les niveaux 3 et 8
                    // => préparer le "pont bilateral gauche" sur le même niveau
                    return;
                }

                //Si la serie théorique et la 3ème, mais le temps de l'exercice en serie 1 < 60 : on a finit
                if (next.serieIndex == 2) { //On vient de finir la 2ème série
                    var i = 0;
                    while ((this.results[2][next.exerciseIndex].toSkip == true)
                    && (i < 50)) {
                        next = this.getNextExercise(this.results, next.serieIndex, next.exerciseIndex);
                        i++;
                        if(next.end) {
                            //On a finit les exercices, on génére le programm
                            console.log("la fin avant de changer de page");
                            this.$store.dispatch('updateResults', this.results);
                            this.$router.push({path: '/program'});
                            return;
                        }
                    }


                    //Le niveau de l'exercice de la série n°3 est le même que le niveau de la série 2
                    // this.results[2][next.exerciseIndex].level = this.results[1][next.exerciseIndex].level;
                    this.results[2][next.exerciseIndex].level =
                        this.findObjectByKey(this.exercises[next.exerciseIndex].levels, 'rank',
                            this.results[1][next.exerciseIndex].level.rank);


                }

                this.exerciseIndex  = next.exerciseIndex;
                this.serieIndex     = next.serieIndex;
                return;
            },

            previousStep: function () {
                //Ce n'est pas le premier exercice de la série
                let exerciseIndex = this.exerciseIndex;
                let serieIndex = this.serieIndex;
                let i=0; //Sécurité anti bug de boucle infinie
               do {
                    if (exerciseIndex >= 1) {
                        exerciseIndex--;

                    } else {
                        exerciseIndex = this.exercises.length-1;
                        if(serieIndex >= 1) {
                            serieIndex--;
                        }
                    }
                    i++;

               } while (i < 20 && (this.results[serieIndex][exerciseIndex].duration == null));
                //affetation des valeurs trouvées
                this.exerciseIndex = exerciseIndex;
                this.serieIndex = serieIndex;
                //mise à jour du chronomètre : valeur à celle mesurée et isRunning à false

            },
            imageLink: function (exerciseIndex, level) {
                return 'src/assets/images/' + this.exercises[exerciseIndex].images[level - 1];
            },
        },
        created: function() {
            //Récupération des exercises depuis le store
            this.exercises = this.$store.getters.exercises;
            //Initialisation du niveau par défaut dans les résultats
            this.results = this.$store.getters.results;

            for (const key1 of this.results.keys()) {
                for (const key2 of this.results[key1].keys()) {
                    this.results[key1][key2].level = this.findObjectByKey(this.exercises[key2].levels, 'rank',
                        this.exercises[key2].defaultLevel);
                    this.results[key1][key2].toSkip = true;
                }
            }


            /* utilisation du local storage */
            let userParams = this.$store.getters.userParams;
            if((userParams.localStorage == true)
                && userParams.defaultLevels.length > 0) {
                this.results = this.$store.getters.results;
                for (const key1 of this.results.keys()) {
                    for (const key2 of this.results[key1].keys()) {
                        if(userParams.defaultLevels[key2] != undefined) {
                            this.results[key1][key2].level = this.findObjectByKey(this.exercises[key2].levels, 'rank',
                                userParams.defaultLevels[key2]);
                        }
                    }
                }
            }

        },
    }


</script>


// WEBPACK FOOTER //
// src/components/Training.vue